import { render, staticRenderFns } from "./TblDeviceDetailCustom.vue?vue&type=template&id=c9f4c01a&scoped=true&"
import script from "./TblDeviceDetailCustom.vue?vue&type=script&lang=js&"
export * from "./TblDeviceDetailCustom.vue?vue&type=script&lang=js&"
import style0 from "./TblDeviceDetailCustom.vue?vue&type=style&index=0&id=c9f4c01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f4c01a",
  null
  
)

export default component.exports